// extracted by css-extract-rspack-plugin
export default {"item":"item-mro0ab","active":"active-psET0A","icon":"icon-qoI0kG","label":"label-FLwbTF","badge":"badge-dhOPGQ"};